import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPowerTranzAccountStatus } from "store/payment-provider"
import { powerTranzSettingsAccountSelector } from "store/user"

// Whether a "connect a payment provider" prompt should also offer PowerTranz: the web app has it on,
// the API's PowerTranz switch answers (not 404) and the guide is in the pilot. A pilot guide who never
// connected has nothing in GET /user, so this asks the status endpoint — once, and only while a
// prompt is on screen (isNeeded).
export const usePowerTranzConnectOffer = (isNeeded = true) => {
  const dispatch = useDispatch()
  const isAvailable = useSelector((state) => state.paymentProvider.powerTranzAccount.isAvailable)
  const isLoading = useSelector((state) => state.paymentProvider.getPowerTranzAccountStatus.loading)
  const account = useSelector(powerTranzSettingsAccountSelector)

  useEffect(() => {
    if (!isNeeded || isAvailable !== null || isLoading) return
    dispatch(getPowerTranzAccountStatus()).catch(() => {})
  }, [dispatch, isNeeded, isAvailable, isLoading])

  return isAvailable === true && account.isEligible
}
